// export const discogsURL = 'http://localhost:5001'
export const cognitoURL = 'https://vinylscanner.auth.us-east-2.amazoncognito.com'
// export const baseURL = 'http://localhost:5000'
export const baseURL = 'https://api-vinylscanner.herokuapp.com'
